"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomCharacter = exports.range = exports.columns = exports.toArray = void 0;
var toArray = function (obj) {
    if (!obj) {
        return [];
    }
    return Object.keys(obj).reduce(function (previousValue, current) {
        var val = obj[current];
        if (typeof val === 'string') {
            return __spreadArray(__spreadArray([], previousValue, true), [val], false);
        }
        return __spreadArray(__spreadArray([], previousValue, true), (0, exports.toArray)(val), true);
    }, []);
};
exports.toArray = toArray;
var columns = function (array, cols) {
    if (!array || array.length <= 0) {
        return [];
    }
    var num = cols <= 0 ? 1 : cols;
    var sliced = __spreadArray([], array, true);
    var updated = [];
    while (sliced.length) {
        updated.push(sliced.splice(0, num));
    }
    return updated;
};
exports.columns = columns;
var range = function (start, end) {
    var length = end - start + 1;
    return Array.from({ length: length }, function (_, idx) { return idx + start; });
};
exports.range = range;
var getRandomCharacter = function () {
    return Math.random()
        .toString(36)
        .charAt(Math.floor(Math.random() * 36));
};
exports.getRandomCharacter = getRandomCharacter;
